import useGet from './use-get'
import useCreate from './use-create'
import useGetFoundersReport from './use-get-founders-report'
import useGetMarketCapacityReport from './use-get-market-capacity-report'
import useGetMarketResultsReport from './use-get-market-results-report'
import useGetSeoReport from './use-get-seo-report'
import useGetOne from './use-get-one'
import useGetStatistics from './use-get-statistics'
import useGetProjectFiles from './use-get-project-files'
import useGetProjectMembers from './use-get-project-members'
import useGetProjectCase from './use-get-project-case'
import useUpdateProject from './use-update-project'
import useUploadProjectFile from './use-upload-project-file'
import useGetMetrics from './use-get-metrics'
import useCreateGrowthPointBasics from './use-create-growth-point-basics'

const queries = {
  useGet,
  useCreate,
  useGetFoundersReport,
  useGetMarketCapacityReport,
  useGetMarketResultsReport,
  useGetSeoReport,
  useGetOne,
  useGetStatistics,
  useGetProjectFiles,
  useGetProjectMembers,
  useGetProjectCase,
  useUpdateProject,
  useUploadProjectFile,
  useGetMetrics,
  useCreateGrowthPointBasics,
}

export default queries
